/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { NoItemRow, TizetiGIFLogoTable } from '../../../../utils/loader/loadingHelper';

const InstallationTable = ({ loader, items }) => {
    console.log(items,"this is", loader);
  const colSpan = '8';
  const installsTable = () => {
    if (items) {
      return (
        <div className="ml-4 table-responsive col-12">
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Payment REF</th>
                <th>User Address</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Zone</th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TizetiGIFLogoTable colSpan={colSpan} />
                ) : items && items.length ? (
                    items.map((item, i) => {
                 
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{item.user.firstName + " " + item.user.lastName}</td>
                      <td>{item.payment_reference}</td>
                      <td>{item.address}</td>
                      <td>{item.user.email}</td>
                      <td>{item.user.phoneNumber}</td>
                      <td>{item.zone.name}</td>
                    
                    </tr>
                  );
                })
              ) : (
                <NoItemRow
                  colSpan={colSpan}
                  text='No Rescheduled Installations'
                />
              )}
            </tbody>
          </table>
        </div>
      );
    }
    return <TizetiGIFLogoTable colSpan={colSpan}  />;
  };

  return installsTable();
};

export default InstallationTable;
